import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from '@/assets/images/icons/fe64f10fae14ac626dda3c2b4dd4c991.png';
var _hoisted_1 = {
  class: "d-flex fl-col fl-s-b aside-wrapper",
  "data-cy": "aside-order-summary"
};
var _hoisted_2 = {
  class: "order-summary-wrapper d-flex fl-col fl-s-b scroll-y"
};
var _hoisted_3 = {
  class: "scroll-y order-summary d-flex fl-col fl-s-b"
};
var _hoisted_4 = {
  class: "upper-part-container d-flex flex-row fl-s-b"
};
var _hoisted_5 = {
  class: "title d-flex fl-col fl-j-c"
};
var _hoisted_6 = {
  class: "order-reference-wrapper"
};
var _hoisted_7 = {
  class: "order-reference",
  "data-cy": "order-reference"
};
var _hoisted_8 = {
  class: "clipboard"
};
var _hoisted_9 = {
  class: "icon-container"
};
var _hoisted_10 = {
  class: "max-content-width"
};
var _hoisted_11 = {
  class: "pss-list-container d-flex fl-col fl-s-a"
};
var _hoisted_12 = {
  key: 0
};
var _hoisted_13 = {
  class: "pss-container d-flex flex-row fl-s-b"
};
var _hoisted_14 = {
  class: "ticket-name-container"
};
var _hoisted_15 = {
  class: "ticket-name"
};
var _hoisted_16 = {
  key: 0,
  class: "price-name"
};
var _hoisted_17 = {
  key: 1,
  class: "timeslot"
};
var _hoisted_18 = {
  key: 2,
  class: "seat"
};
var _hoisted_19 = {
  key: 3,
  class: "ticket-discount-info"
};
var _hoisted_20 = {
  class: "quantity-container"
};
var _hoisted_21 = ["onClick"];
var _hoisted_22 = {
  class: "unit-price-container"
};
var _hoisted_23 = {
  key: 0,
  class: "total-price"
};
var _hoisted_24 = {
  key: 0,
  class: "tickets-status-container"
};
var _hoisted_25 = {
  key: 0,
  class: "w-100 d-flex flex-1 fl-s-e fl-a-c"
};
var _hoisted_26 = {
  class: "total-container text-left",
  style: {
    "width": "33%"
  }
};
var _hoisted_27 = {
  class: "total-container text-center",
  style: {
    "width": "33%"
  }
};
var _hoisted_28 = {
  class: "total-container text-right",
  style: {
    "width": "33%"
  }
};
var _hoisted_29 = {
  key: 1,
  class: "w-100 d-flex flex-1 fl-s-e fl-a-c"
};
var _hoisted_30 = {
  class: "total-container text-left",
  style: {
    "width": "33%"
  }
};
var _hoisted_31 = {
  class: "total-container text-center",
  style: {
    "width": "33%"
  }
};
var _hoisted_32 = {
  class: "total-container text-right",
  style: {
    "width": "33%"
  }
};
var _hoisted_33 = {
  key: 2,
  class: "w-100 d-flex flex-1 fl-s-e fl-a-c"
};
var _hoisted_34 = {
  class: "total-container text-left",
  style: {
    "width": "33%"
  }
};
var _hoisted_35 = {
  class: "total-container text-center",
  style: {
    "width": "33%"
  }
};
var _hoisted_36 = {
  class: "total-container text-right",
  style: {
    "width": "33%"
  }
};
var _hoisted_37 = {
  key: 3
};
var _hoisted_38 = {
  key: 0,
  class: "w-100 d-flex flex-1 fl-s-e fl-a-c"
};
var _hoisted_39 = {
  class: "total-container text-left",
  style: {
    "width": "33%"
  }
};
var _hoisted_40 = {
  class: "total-container text-center p-rel",
  style: {
    "width": "33%"
  }
};
var _hoisted_41 = {
  style: {
    "position": "absolute",
    "right": "-1rem"
  }
};
var _hoisted_42 = {
  class: "total-container text-right",
  style: {
    "width": "33%"
  }
};
var _hoisted_43 = {
  key: 4,
  class: "w-100 d-flex flex-1 fl-s-e fl-a-c"
};
var _hoisted_44 = {
  class: "total-container text-left",
  style: {
    "width": "33%"
  }
};
var _hoisted_45 = {
  class: "total-container text-center",
  style: {
    "width": "33%"
  }
};
var _hoisted_46 = {
  class: "total-container text-right",
  style: {
    "width": "33%"
  }
};
var _hoisted_47 = {
  key: 5,
  style: {
    "padding-top": "40px"
  }
};
var _hoisted_48 = {
  key: 0,
  style: {
    "font-size": "11px",
    "font-weight": "400"
  }
};
var _hoisted_49 = {
  class: "text-center",
  style: {
    "width": "33%"
  }
};
var _hoisted_50 = {
  class: "d-flex flex-row fl-s-b",
  style: {
    "width": "33%"
  }
};
var _hoisted_51 = {
  class: "d-flex fl-col fl-j-c"
};
var _hoisted_52 = ["onClick"];
var _hoisted_53 = {
  key: 6,
  style: {
    "border-top": "2px solid white"
  }
};
var _hoisted_54 = {
  class: "d-flex flex-1 fl-s-e fl-a-c",
  style: {
    "margin-bottom": "-15px"
  }
};
var _hoisted_55 = {
  class: "confirmed-amount-total text-left",
  style: {
    "width": "33%"
  }
};
var _hoisted_56 = {
  class: "confirmed-amount-total text-center",
  style: {
    "width": "33%"
  }
};
var _hoisted_57 = {
  class: "confirmed-amount-total text-right",
  style: {
    "width": "33%"
  }
};
var _hoisted_58 = {
  key: 0,
  class: "d-flex flex-1 fl-s-e fl-a-c",
  style: {
    "margin-bottom": "-15px"
  }
};
var _hoisted_59 = {
  class: "confirmed-amount-total text-left",
  style: {
    "width": "33%"
  }
};
var _hoisted_60 = {
  class: "confirmed-amount-total text-center",
  style: {
    "width": "33%"
  }
};
var _hoisted_61 = {
  class: "confirmed-amount-total text-right",
  style: {
    "width": "33%"
  }
};
var _hoisted_62 = {
  class: "accountings-container d-flex flex-row fl-s-b"
};
var _hoisted_63 = {
  class: "title d-flex fl-col fl-j-c"
};
var _hoisted_64 = {
  key: 0,
  class: "value d-flex fl-col fl-j-c"
};
var _hoisted_65 = {
  key: 1,
  class: "value d-flex fl-col fl-j-c"
};
var _hoisted_66 = {
  key: 1,
  class: "calculator-wrapper"
};
var _hoisted_67 = {
  key: 2,
  class: "cancel-tickets-popup"
};
var _hoisted_68 = {
  class: "confirmed-tickets-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$selectedBooking2, _ctx$selectedBooking3, _ctx$selectedBooking4, _ctx$splitPayments, _ctx$selectedBooking5, _ctx$selectedBooking6, _ctx$selectedBooking7;

  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_col = _resolveComponent("el-col");

  var _component_el_row = _resolveComponent("el-row");

  var _component_el_button = _resolveComponent("el-button");

  var _component_numeric_calculator = _resolveComponent("numeric-calculator");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("p", {
    class: _normalizeClass({
      'long-title': _ctx.isLongTitle,
      'max-content-width': !_ctx.isLongTitle
    })
  }, _toDisplayString(_ctx.$t("asideordersummary.title")), 3), _createElementVNode("div", _hoisted_6, [_createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("orders.reference")) + ": " + _toDisplayString(_ctx.orderReference), 1), _createElementVNode("div", _hoisted_8, [_createVNode(_component_SvgIcon, {
    iconContent: _ctx.copyIcon,
    iconStyle: "width: 12px; height: 12px; cursor:pointer;",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.copyToClipboard(_ctx.orderReference);
    })
  }, null, 8, ["iconContent"]), _ctx.showCopyCheck ? (_openBlock(), _createBlock(_component_SvgIcon, {
    key: 0,
    iconContent: _ctx.check,
    iconStyle: "width: 12px; height: 12px; cursor:pointer",
    class: "check"
  }, null, 8, ["iconContent"])) : _createCommentVNode("", true)])])]), _createElementVNode("div", {
    class: "assign-customer-btn-container d-flex flex-row fl-s-b flex-align-center",
    onClick: _cache[1] || (_cache[1] = //@ts-ignore
    function () {
      return _ctx.onClickCustomers && _ctx.onClickCustomers.apply(_ctx, arguments);
    })
  }, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_SvgIcon, {
    iconContent: _ctx.iconContent,
    iconAlt: _ctx.iconAlt,
    iconStyle: _ctx.iconStyle
  }, null, 8, ["iconContent", "iconAlt", "iconStyle"])]), _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.getCustomerFullName), 1)])]), _createElementVNode("div", _hoisted_11, [_ctx.groupedPSSList ? (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedPSSList, function (pss) {
    return _openBlock(), _createElementBlock("div", {
      key: String(pss.uuid),
      class: _normalizeClass(pss.bookingStatus === _ctx.BookingStatus.Canceled ? 'cancelled-pss-container' : '')
    }, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("p", _hoisted_15, _toDisplayString( // In case of a retail with only one option which is the default one we show category name
    pss.pssType === _ctx.PSSType[_ctx.PSSType.Retail] ? pss.optionName || pss.categoryName : pss.categoryName), 1), _ctx.showTicketInfo(pss) ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(pss.priceName), 1)) : _createCommentVNode("", true), _ctx.showTicketInfo(pss) ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.formatDateTime(pss.startDateTime)), 1)) : _createCommentVNode("", true), pss.seats && pss.seats.length ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(pss.seats.length > 1 ? "".concat(_ctx.t("field.seat"), ": ").concat(pss.seats.join(", ")) : "".concat(_ctx.t("field.seat"), ": ").concat(pss.seats[0])), 1)) : _createCommentVNode("", true), (_ctx.hasGenericDiscountAccountings(pss) || _ctx.isPSSConsideredInDiscount1(pss)) && !_ctx.isFreeTicket(pss) ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.getTicketDiscount1(pss)), 1)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTicketAppliedDiscountCodes(pss), function (line) {
      return _openBlock(), _createElementBlock("p", {
        class: "ticket-discount-info",
        key: line
      }, _toDisplayString(line), 1);
    }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTicketAppliedOffers(pss), function (line) {
      return _openBlock(), _createElementBlock("p", {
        class: "ticket-discount-info",
        key: line
      }, _toDisplayString(line), 1);
    }), 128))]), _createElementVNode("div", _hoisted_20, [_createElementVNode("p", {
      class: _normalizeClass(["quantity", pss.bookingStatus === _ctx.BookingStatus.Canceled ? 'erased-tickets' : ''])
    }, " X" + _toDisplayString(pss.quantity), 3), _ctx.showRemoveBtn(pss) ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: _imports_0,
      class: "remove-btn",
      onClick: function onClick($event) {
        return _ctx.deleteTickets(pss.pssIds);
      },
      "data-cy": "remove-pss-button"
    }, null, 8, _hoisted_21)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_22, [_createElementVNode("p", {
      class: _normalizeClass(["unit-price", pss.bookingStatus === _ctx.BookingStatus.Canceled ? 'erased-tickets' : ''])
    }, _toDisplayString((_ctx.getPSSValue(pss) / 100).toFixed(2)), 3)]), _createElementVNode("div", {
      class: _normalizeClass(["total-price-container", {
        'with-pt': _ctx.getPssGroupDiscount(pss, false)
      }])
    }, [_createElementVNode("p", {
      class: _normalizeClass(["total-price", {
        'erased-tickets': pss.bookingStatus === _ctx.BookingStatus.Canceled || _ctx.getPssGroupDiscount(pss, false)
      }])
    }, _toDisplayString((_ctx.getPSSValue(pss) / 100 * pss.quantity).toFixed(2)), 3), _ctx.getPssGroupDiscount(pss, false) ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString((_ctx.getPSSValue(pss) / 100 * pss.quantity - _ctx.getPssGroupDiscount(pss, false) / 100).toFixed(2)), 1)) : _createCommentVNode("", true)], 2)]), (pss.bookingStatus === _ctx.BookingStatus.Confirmed || pss.bookingStatus === _ctx.BookingStatus.Canceled) && _ctx.isEditOrder ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("p", null, _toDisplayString(_ctx.getStatusTranslation(pss)), 1)])) : _createCommentVNode("", true)], 2);
  }), 128))])) : _createCommentVNode("", true), _ctx.isInPaymentStep && _ctx.discountTotal1 ? (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    class: "total-container discount-container",
    justify: "start"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 5,
        class: "total-container"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString("".concat(_ctx.$t("button.discount"), ":")), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 5,
        class: "total-container d-flex fl-a-c fl-j-e"
      }, {
        default: _withCtx(function () {
          var _ctx$selectedBooking;

          return [_createTextVNode(_toDisplayString((_ctx$selectedBooking = _ctx.selectedBooking) === null || _ctx$selectedBooking === void 0 ? void 0 : _ctx$selectedBooking.currency), 1)];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 11,
        class: "d-flex flex-row fl-a-c fl-j-e"
      }), _createVNode(_component_el_col, {
        class: "total-container text-right",
        span: 3
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString((_ctx.discountTotal1 / 100).toFixed(2)), 1)];
        }),
        _: 1
      })];
    }),
    _: 1
  })) : _createCommentVNode("", true)]), _ctx.isInPaymentStep || _ctx.isCompletedBooking ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, _toDisplayString("".concat(_ctx.$t("field.subtotal"), ":")), 1), _createElementVNode("div", _hoisted_27, _toDisplayString((_ctx$selectedBooking2 = _ctx.selectedBooking) === null || _ctx$selectedBooking2 === void 0 ? void 0 : _ctx$selectedBooking2.currency), 1), _createElementVNode("div", _hoisted_28, _toDisplayString((Number(_ctx.total1) - Number(_ctx.totalTax)).toFixed(2)), 1)])) : _createCommentVNode("", true), _ctx.isInPaymentStep || _ctx.isCompletedBooking ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, _toDisplayString("".concat(_ctx.$t("field.vat"), ":")), 1), _createElementVNode("div", _hoisted_31, _toDisplayString((_ctx$selectedBooking3 = _ctx.selectedBooking) === null || _ctx$selectedBooking3 === void 0 ? void 0 : _ctx$selectedBooking3.currency), 1), _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.totalTax), 1)])) : _createCommentVNode("", true), (_ctx.isInPaymentStep || _ctx.isCompletedBooking) && !_ctx.isEditOrder ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, _toDisplayString("".concat(_ctx.$t("field.total"), ":")), 1), _createElementVNode("div", _hoisted_35, _toDisplayString((_ctx$selectedBooking4 = _ctx.selectedBooking) === null || _ctx$selectedBooking4 === void 0 ? void 0 : _ctx$selectedBooking4.currency), 1), _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.total1), 1)])) : _createCommentVNode("", true), (_ctx.isInPaymentStep || _ctx.isCompletedBooking) && !_ctx.isEditOrder && (_ctx$splitPayments = _ctx.splitPayments) !== null && _ctx$splitPayments !== void 0 && _ctx$splitPayments.length ? (_openBlock(), _createElementBlock("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currenciesUsedInPayment, function (currency, index) {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [currency && currency.label !== _ctx.groupCurrency.label ? (_openBlock(), _createElementBlock("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, _toDisplayString("".concat(_ctx.$t("field.total"), ":")), 1), _createElementVNode("div", _hoisted_40, [_createTextVNode(_toDisplayString(currency.label) + " ", 1), _createElementVNode("span", _hoisted_41, "R " + _toDisplayString(currency.exchangeRate), 1)]), _createElementVNode("div", _hoisted_42, _toDisplayString((Number(_ctx.total1) * currency.exchangeRate).toFixed(2)), 1)])) : _createCommentVNode("", true)]);
  }), 128))])) : _createCommentVNode("", true), _ctx.isEditOrder ? (_openBlock(), _createElementBlock("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, _toDisplayString("".concat(_ctx.$t("field.total"), ":")), 1), _createElementVNode("div", _hoisted_45, _toDisplayString((_ctx$selectedBooking5 = _ctx.selectedBooking) === null || _ctx$selectedBooking5 === void 0 ? void 0 : _ctx$selectedBooking5.currency), 1), _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.orderValueExcludingCancelledTickets), 1)])) : _createCommentVNode("", true), _ctx.splitPayments && _ctx.splitPayments.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_47, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.splitPayments, function (payment) {
    var _payment$currency;

    return _openBlock(), _createElementBlock("div", {
      key: payment.method,
      class: "w-100 d-flex flex-1 fl-s-e fl-a-c amounts-paid",
      style: {
        "min-height": "25px"
      }
    }, [_createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(payment.translatedMethod), 1), payment.isVoucherPaymentPending ? (_openBlock(), _createElementBlock("span", _hoisted_48, "Pending Payment")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_49, [_createElementVNode("p", null, _toDisplayString((_payment$currency = payment.currency) === null || _payment$currency === void 0 ? void 0 : _payment$currency.label), 1)]), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", _hoisted_51, [_ctx.showRemovePaymentBtn(payment) ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      style: {
        "height": "17px",
        "width": "17px",
        "cursor": "pointer",
        "margin-right": "5px"
      },
      src: _imports_0,
      class: "remove-btn",
      onClick: function onClick($event) {
        return _ctx.removePayment(payment.accountingUuid);
      }
    }, null, 8, _hoisted_52)) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(payment.cashBill ? payment.cashBill.toFixed(2) : (payment.amount * (payment.exchangeRate || 1)).toFixed(2)), 1)])])]);
  }), 128))])) : _createCommentVNode("", true), _ctx.splitPayments && _ctx.splitPayments.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.$t("asideordersummary.amount-confirmed")), 1), _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.payingCurrency), 1), _createElementVNode("div", _hoisted_57, _toDisplayString((_ctx.amountPaid / 100).toFixed(2)), 1)]), _ctx.isEditOrder ? (_openBlock(), _createElementBlock("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.$t("asideordersummary.amount-refunded")), 1), _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.payingCurrency), 1), _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.refundedAmount.toFixed(2)), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_62, [_createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.$t("asideordersummary.balance-in")) + " " + _toDisplayString(_ctx.currency), 1), !((_ctx$selectedBooking6 = _ctx.selectedBooking) !== null && _ctx$selectedBooking6 !== void 0 && _ctx$selectedBooking6.type) || ((_ctx$selectedBooking7 = _ctx.selectedBooking) === null || _ctx$selectedBooking7 === void 0 ? void 0 : _ctx$selectedBooking7.type) !== _ctx.BookingType.Invoice ? (_openBlock(), _createElementBlock("p", _hoisted_64, _toDisplayString(_ctx.whatIsLeftToPay), 1)) : (_openBlock(), _createElementBlock("p", _hoisted_65, _toDisplayString(_ctx.whatIsLeftToPayForInvoice), 1))])])]), _ctx.isInOrderStep || _ctx.isInPaymentStep ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return _ctx.calcVisibility = !_ctx.calcVisibility;
    }),
    size: "large",
    class: _normalizeClass(['w-100', 'f-bold', 'keyboard-button', {
      'd-none': _ctx.calcVisibility && _ctx.isInOrderStep
    }]),
    disabled: !_ctx.isInOrderStep
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_SvgIcon, {
        iconContent: _ctx.calcIcon,
        iconAlt: _ctx.calcAlt,
        iconStyle: _ctx.calcIconStyle
      }, null, 8, ["iconContent", "iconAlt", "iconStyle"])];
    }),
    _: 1
  }, 8, ["class", "disabled"])) : _createCommentVNode("", true), _ctx.calcVisibility && _ctx.isInOrderStep ? (_openBlock(), _createElementBlock("div", _hoisted_66, [_createVNode(_component_numeric_calculator, {
    visible: _ctx.calcVisibility,
    onCloseCalc: _ctx.closeCalculator
  }, null, 8, ["visible", "onCloseCalc"])])) : _createCommentVNode("", true), _ctx.showCancelTicketsModal ? (_openBlock(), _createElementBlock("div", _hoisted_67, [_createVNode(_component_el_dialog, {
    title: 'Tickets Cancellation',
    width: "80%",
    modelValue: _ctx.showCancelTicketsModal,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
      return _ctx.showCancelTicketsModal = $event;
    }),
    "show-close": false,
    "close-on-click-modal": false,
    "close-on-press-escape": false
  }, {
    footer: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_button, {
        plain: "",
        onClick: _ctx.closeModal,
        "data-cy": "dismiss-cancel-tickets-modal-button"
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("button.dismiss")), 1)];
        }),
        _: 1
      }, 8, ["onClick"])])];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_68, [_createVNode(_component_el_row, {
        style: {
          "font-weight": "700",
          "border-bottom": "1px solid grey",
          "padding-bottom": "15px",
          "padding-top": "15px"
        }
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 4
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("common.ticket-name")), 1)];
            }),
            _: 1
          }), _ctx.confirmedPSSToDelete[0].seat ? (_openBlock(), _createBlock(_component_el_col, {
            key: 0,
            span: 4
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("field.seat")), 1)];
            }),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
            span: 4
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("common.price-name")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 4
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("common.price-value")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 4
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("common.bar-code")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 4
          })];
        }),
        _: 1
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.confirmedPSSToDelete, function (pss, index) {
        return _openBlock(), _createElementBlock("div", {
          key: pss.uuid || index
        }, [_createVNode(_component_el_row, {
          style: _normalizeStyle([{
            "padding-bottom": "15px",
            "padding-top": "15px"
          }, index !== _ctx.confirmedPSSToDelete.length - 1 ? 'border-bottom: 1px solid grey' : ''])
        }, {
          default: _withCtx(function () {
            return [_createVNode(_component_el_col, {
              style: {
                "text-align": "left",
                "font-weight": "700"
              },
              span: 4,
              class: "d-flex fl-col fl-j-c"
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("p", null, _toDisplayString(pss.categoryName), 1)];
              }),
              _: 2
            }, 1024), _ctx.confirmedPSSToDelete[0].seat ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              style: {
                "text-align": "left",
                "font-weight": "700"
              },
              span: 4,
              class: "d-flex fl-col fl-j-c"
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("p", null, _toDisplayString(pss.seat), 1)];
              }),
              _: 2
            }, 1024)) : _createCommentVNode("", true), _createVNode(_component_el_col, {
              span: 4,
              class: "d-flex fl-col fl-j-c"
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("p", null, _toDisplayString(pss.priceName), 1)];
              }),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              span: 4,
              class: "d-flex fl-col fl-j-c"
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("p", null, _toDisplayString(_ctx.getPackageTotalValue(pss) / 100 + " " + _ctx.currency), 1)];
              }),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              span: 4,
              class: "d-flex fl-col fl-j-c"
            }, {
              default: _withCtx(function () {
                var _pss$barCode;

                return [_createElementVNode("p", null, _toDisplayString((_pss$barCode = pss.barCode) !== null && _pss$barCode !== void 0 ? _pss$barCode : "-"), 1)];
              }),
              _: 2
            }, 1024), _createVNode(_component_el_col, {
              span: 4,
              style: {
                "text-align": "right",
                "padding-right": "10px"
              },
              class: "d-flex fl-col fl-j-c"
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("div", null, [pss.bookingStatus === _ctx.BookingStatus.Confirmed ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "danger",
                  icon: _ctx.DeleteIcon,
                  circle: "",
                  onClick: function onClick($event) {
                    return _ctx.openMessageBox(pss);
                  },
                  loading: _ctx.isRemoveButtonLoading,
                  "data-cy": "confirm-remove-pss-button"
                }, null, 8, ["icon", "onClick", "loading"])) : _createCommentVNode("", true)])];
              }),
              _: 2
            }, 1024)];
          }),
          _: 2
        }, 1032, ["style"])]);
      }), 128))])];
    }),
    _: 1
  }, 8, ["modelValue"])])) : _createCommentVNode("", true)]);
}